<template>
    <div class="export-item flex flex-col justify-center">
        <div class="flex items-center justify-between">
            <div class="text-small">
                <div :class="{ 'text-danger': status === 'failed' }" class="truncate">{{ item.file_name }}</div>
            </div>
            <div class="flex h-5 w-11 items-center justify-center">
                <button
                    v-if="status === 'completed'"
                    v-c-tooltip="{ content: trans('general.action.download') }"
                    class="btn btn-link btn-sm !h-5 w-11 min-w-0 p-0"
                    type="button"
                    @click="emit('download', item)"
                >
                    <icon name="cil-cloud-download" />
                </button>
                <button
                    v-else-if="status === 'failed'"
                    v-c-tooltip="{ content: trans('general.action.retry') }"
                    class="btn btn-link btn-sm !h-5 w-11 min-w-0 p-0"
                    type="button"
                    @click="emit('retry', item.id)"
                >
                    <icon name="cil-reload" />
                </button>
                <spinner v-else-if="status === 'started'" size="sm" />
            </div>
        </div>
        <progress v-if="status === 'started'" :max="100" :value="progress" class="progress animated !h-1 w-full bg-primary">{{ progress }}%</progress>
        <div v-if="status" class="text-small text-muted">
            <div v-if="status === 'pending'">{{ trans('general.label.queued') }}</div>
            <div v-else-if="status === 'started'" class="flex justify-between gap-2">
                <div>{{ trans('general.label.generating') }}</div>
                <div>{{ progress }}%</div>
            </div>
            <div v-else-if="status === 'completed'" class="flex justify-end gap-2">
                <div v-if="item.size_in_bytes != null">{{ $filters.prettyBytes(item.size_in_bytes, currentLocale) }}</div>
            </div>
            <div v-else-if="status === 'failed'" class="text-danger" v-html="trans('general.export.failed', { file: '' })" />
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const props = defineProps({
    item: Object,
    progress: Number,
});

const currentLocale = computed(() => usePage().props.locale);

const status = computed(() => {
    return props.item.status.value;
});

const emit = defineEmits(['download', 'retry']);
</script>
<style scoped>
.progress::-webkit-progress-bar {
    background-color: #ececec;
}

.progress::-webkit-progress-value {
    background-color: #2c54ea;
}

.progress::-moz-progress-bar {
    background-color: #2c54ea;
}
</style>
